import React, { useEffect } from 'react';
import { useHistory } from 'react-router';

import { Loader } from 'ui/patterns';

export const Logout = () => {
  const history = useHistory();
  useEffect(() => {
    history.push('/home');
  }, [history]);
  return <Loader />;
};
